import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IQuotation, IQuotationState } from "./quotationModel";
import {
  getAllQuotation,
  getQuotationByID,
} from "./services/quotation.services";

const initialState: IQuotationState = {
  loading: false,
  error: "",
  QuotationID: null,
  QuotationList: [],
  QuotationDetail: {
    FirstName: "",
    LastName: "",
    Email: "",
    PhoneNo: "",
    DateOfBirth: "",
    TotalPax:null,
    TotalTax: 0,
    NoOfProperties: null,
    Address: "",
    IsNewComer: "",
    Dependents: null,
    Services: [
      {
        ServiceID: null,
        ServiceName: "",
        Description: "",
        Charges: null,
        OrderNo: null,
      },
    ],
    IsActive: 1,
  },
};

const quotationSlice = createSlice({
  name: "quotation",
  initialState,
  reducers: {
    setQuotationID: (state, action) => {
      state.QuotationID = action.payload;
    },
    clearQuotationID: (state) => {
      state.QuotationID = initialState.QuotationID;
    },
    clearQuotationDetail: (state) => {
      state.QuotationDetail = initialState.QuotationDetail;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllQuotation.fulfilled,
      (state, action: PayloadAction<IQuotation[]>) => {
        state.loading = false;
        state.QuotationList = action.payload || [];
      }
    );
    builder.addCase(getAllQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.QuotationList = [];
    });

    builder.addCase(getQuotationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getQuotationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.QuotationDetail = action.payload;
    });
    builder.addCase(getQuotationByID.rejected, (state, action) => {
      state.loading = false;
      state.QuotationDetail = initialState.QuotationDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearQuotationID, setQuotationID, clearQuotationDetail } =
  quotationSlice.actions;
export default quotationSlice.reducer;
